import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { AzureMySqlTableDataset } from 'app/model/dataset/azure-mysql-table.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureMySqlTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class AzureMySqlDatasetAdapter extends TabularTypeDatasetAdapter<AzureMySqlTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: AzureMySqlTableDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(AzureMySqlTableDataset).name,
            undefined,
            undefined,
            undefined,
            undefined,
            __IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric ? AzureMySqlTableDataset.DATABASE : undefined);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: AzureMySqlTableDataset): Promise<AzureMySqlTableDataset> {
        return await this._toModelInternal(modelDatasetResource,
            dataset,
            AzureMySqlTableDataset.MODEL,
            undefined,
            undefined,
            undefined,
            undefined,
            __IS_FABRIC_DPE__ || this.context.adapterConfig.convertToFabric ? AzureMySqlTableDataset.DATABASE : undefined);
    }
}
